import { paymentLinksTranslations } from "./payment-links-pt-br";

export const paymentLinks_ES_ES: paymentLinksTranslations = {
	title: "Enlaces de pago",
	description: "Crea y haz seguimiento de cobros puntuales del establecimiento.",
	searchPlaceholder: "Buscar por ID o descripción",
	filters: {
		status: "Estado",
		dateStart: "Fecha inicial",
		dateEnd: "Fecha final",
		dateField: "Filtrar fecha por",
		dateFieldOptions: {
			createdAt: "Creación",
			paidAt: "Pago",
		},
	},
	createButton: "Nuevo cobro",
	empty: "No hay enlaces de pago creados",
	emptyDescription: "Crea un nuevo cobro para generar un enlace de pago.",
	copyLink: "Copiar enlace",
	open: "Abrir",
	linkCopied: "Enlace copiado al portapapeles",
	perPage: "página",
	columns: {
		id: "ID del enlace",
		description: "Descripción",
		amount: "Importe",
		installments: "Máx. cuotas",
		status: "Estado",
		createdAt: "Creado el",
		paidAt: "Pagado el",
		actions: "Acciones",
	},
	status: {
		PENDING: "Pendiente",
		PAID: "Pagado",
		EXPIRED: "Caducado",
		CANCELED: "Cancelado",
	},
	modal: {
		title: "Nuevo cobro",
		amount: "Importe del cobro",
		amountPlaceholder: "€ 0,00",
		installments: "Cantidad máxima de cuotas",
		paymentOrigin: "Cuenta de liquidación",
		description: "Descripción",
		descriptionPlaceholder: "Describe el cobro que verá el pagador",
		cancel: "Cancelar",
		submit: "Generar enlace de pago",
		successMessage: "Enlace de pago creado con éxito",
		requiredField: "Campo obligatorio",
		generatedTitle: "Enlace de pago generado",
		generatedDescription: "Copia y envía el enlace al pagador.",
		copyLink: "Copiar enlace",
		linkCopied: "Enlace copiado al portapapeles",
		done: "Hecho",
	},
};
